import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "patients-list-card trezo-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "trezo-card-header d-sm-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-content" }
const _hoisted_5 = { class: "basic-table table-responsive" }
const _hoisted_6 = { class: "table mb-0" }
const _hoisted_7 = { class: "d-flex align-items-center gap-1" }
const _hoisted_8 = { class: "d-block fw-semibold text-body" }
const _hoisted_9 = { class: "employee-info d-flex align-items-center" }
const _hoisted_10 = { class: "img rounded-circle" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "d-block fw-semibold" }
const _hoisted_13 = { class: "fw-semibold text-primary" }
const _hoisted_14 = { class: "fw-semibold text-body" }
const _hoisted_15 = { class: "fw-semibold text-body" }
const _hoisted_16 = { class: "fw-semibold text-body" }
const _hoisted_17 = { class: "action-buttons d-flex justify-content-end align-items-center" }
const _hoisted_18 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pt-3" }
const _hoisted_19 = { class: "fs-12 fw-medium" }
const _hoisted_20 = { "aria-label": "Page navigation example" }
const _hoisted_21 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_22 = { class: "page-item" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "page-item" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"trezo-card-title\" data-v-164cb827><form class=\"search-box position-relative\" data-v-164cb827><label class=\"text-black\" data-v-164cb827><i class=\"material-symbols-outlined\" data-v-164cb827> search </i></label><input type=\"text\" class=\"input-search d-block w-100 border-radius\" placeholder=\"Search here.....\" data-v-164cb827></form></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          class: "add-btn d-inline-block transition fw-medium border-radius",
          to: "/doctor/add-patient"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "d-inline-block position-relative" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, " add "),
              _createTextVNode(" Add New Patient ")
            ], -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Code"),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Patient"),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Email"),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Phone No."),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Disease"),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Appoint. Date"),
              _createElementVNode("th", {
                scope: "col",
                class: "fw-bold"
              }, "Action")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedPatients, (patient) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: patient.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-check mb-0" }, [
                      _createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox"
                      })
                    ], -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(patient.code), 1)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: patient.image,
                        alt: "user-image",
                        class: "rounded-circle"
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(patient.name), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString(patient.email), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(patient.phone), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(patient.disease), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(patient.appointmentDate), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_RouterLink, {
                      to: "/doctor/patient-details",
                      class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, " visibility ", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("a", {
                      href: "#",
                      class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, " edit ")
                    ], -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("button", {
                      type: "button",
                      class: "p-0 bg-transparent d-inline-block lh-1 border-0"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, " delete ")
                    ], -1))
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, " Showing " + _toDisplayString(_ctx.startIndex + 1) + " to " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.patients.length) + " Results ", 1),
        _createElementVNode("nav", _hoisted_20, [
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", _hoisted_22, [
              _createElementVNode("button", {
                class: "page-link icon",
                "aria-label": "Previous",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                disabled: _ctx.currentPage === 1
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
              ]))], 8, _hoisted_23)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "page-item",
                key: page
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                  onClick: ($event: any) => (_ctx.goToPage(page))
                }, _toDisplayString(page), 11, _hoisted_24)
              ]))
            }), 128)),
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("button", {
                class: "page-link icon",
                "aria-label": "Next",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                disabled: _ctx.currentPage === _ctx.totalPages
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
              ]))], 8, _hoisted_26)
            ])
          ])
        ])
      ])
    ])
  ]))
}